import { ID } from "../types";
import { prune } from "common/utils/utility";
import { Token } from "../token/types";

export class Property {
  id: ID = Property.default().id;
  sharesSold: number = Property.default().sharesSold;
  sharesAvailable: number = Property.default().sharesAvailable;
  sharePrice: number = Property.default().sharePrice;
  cost: number = Property.default().cost;
  value: string = Property.default().value;
  fundingPercetange: number = Property.default().fundingPercetange;
  imageUrl: string = Property.default().imageUrl;
  price: number = Property.default().price;
  cap: number = Property.default().cap;
  total_sold: number = Property.default().total_sold;
  token: Token = Property.default().token;
  selected: boolean = Property.default().selected;
  min: number = Property.default().min;
  max: number = Property.default().max;
  start: string = Property.default().start;
  end: string = Property.default().end;

  constructor(obj: any) {
    obj && Object.assign(this, prune(obj));

    this.token = new Token(obj.token);
  }

  static default(): any {
    return {
      id: "",
      sharesSold: 0,
      sharesAvailable: 0,
      sharesPrice: 0,
      cost: 0,
      value: "",
      fundingPercetange: 0,
      imageUrl: "",
      price: 0,
      cap: 0,
      total_sold: 0,
      token: new Token(null),
      selected: false,
      min: 0,
      max: 0,
      start: "",
      end: "",
    }
  };
}
